
<Card icon="database" :label="__('common.data')">
  <DataGroup>
    <DataGroupItem
      v-for="(value, key) in data"
      :key="key"
      :label="key"
      :html="mapToHumanReadableValue(value)"
      row-class="align-items-start"
    />
  </DataGroup>
  <template #actions>
    <b-button
      v-if="updatePermission"
      size="sm"
      variant="primary"
      class="mr-2"
      data-testid="edit-data-btn"
      @click="openEditModal"
    >
      <Icon icon="edit" class="mr-2" size="14" />
      {{ __('buttons.edit-data') }}
    </b-button>
  </template>
</Card>
